import React from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import GetWordVersion from '@Utils/commonUtils';
import { login, loginUsingSSO } from '@Actions/authentication';
import LoginForm from './components/loginForm';

/* global Office */

const LoginContainer = ({
    url,
    index,
    username,
    password,
    errorUsernameMsg,
    errorPasswordMsg,
    isAuthenticating,
    handleChange,
    handleValidation
}) => {
    const versionInfo = GetWordVersion();

    const dispatch = useDispatch();

    const logIn = event => {
        event.preventDefault();
        handleValidation({
            username,
            password
        });

        if (username && password) {
            dispatch(login(username, password));
        }
    };

    const forgot = () => {
        const forgotUrl = `${url}/forgot-password`;
        const displayInIframe = false;
        const promptBeforeOpen = false;
        Office.context.ui.displayDialogAsync(forgotUrl, {
            height: 80,
            width: 80,
            displayInIframe,
            promptBeforeOpen
        });
    };

    const logInOauth = event => {
        event.preventDefault();
        dispatch(loginUsingSSO());
    };

    return (
        <LoginForm
            isAuthenticating={isAuthenticating}
            login={logIn}
            logInOauth={logInOauth}
            user={{ username, password }}
            handleChange={handleChange}
            errorUsernameMsg={errorUsernameMsg}
            errorPasswordMsg={errorPasswordMsg}
            url={url}
            forgot={forgot}
            isWordOnline={versionInfo.isWordOnline}
            index={index}
        />
    );
};

export default withRouter(LoginContainer);
